import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

// Async thunk for login
export const login = createAsyncThunk("clientAuth/login", async (FormData, thunkAPI) => {
    try {
        const res = await axios.post(
            `${BACKEND_URL}/client/login`,
            FormData
        );
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Login failed");
    }
});

export const signup = createAsyncThunk("clientAuth/signup", async (FormData, thunkAPI) => {
    try {
        const res = await axios.post(
            `${BACKEND_URL}/client/signup`,
            FormData
        );
        return res.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Signup failed");
    }
});

// Forgot Password Thunk
export const clientForgotPassword = createAsyncThunk(
  "clientAuth/forgotPassword",
  async (email, thunkAPI) => {
    try {
      const res = await axios.post(`${BACKEND_URL}/client/forgot-password`, { email });
      return res.data.message || "Reset link sent.";
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.error || "Something went wrong");
    }
  }
);

// Reset Password Thunk
export const clientResetPassword = createAsyncThunk(
  "clientAuth/resetPassword",
  async ({ token, newPassword }, thunkAPI) => {
    try {
      const res = await axios.post(`${BACKEND_URL}/client/reset-password`, {
        token,
        newPassword,
      });
      return res.data.message || "Password reset successful!";
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.error || "Reset failed");
    }
  }
);


export function saveTokenInLocalStorage(access_token, expires_in) {
    // console.log("access_token", access_token);
    // console.log("expires_in", expires_in);
    const expiryTime = new Date().getTime() + expires_in * 1000;
    localStorage.setItem("client_access_token", access_token);
    localStorage.setItem("client_token_expiry", expiryTime);
}

const authFromStorage = localStorage.getItem("client_access_token");
const authSlice = createSlice({
    name: "clientAuth",
    initialState: {
        auth: authFromStorage ? { access_token: authFromStorage } : null,
        loading: false,
        error: null,
    },
    reducers: {
        logout: (state) => {
          state.auth = null;
          state.loading = false;
          state.error = null;

          localStorage.removeItem("client_access_token");
          localStorage.removeItem("client_token_expiry");
          localStorage.removeItem("user_id");
          localStorage.removeItem("user_name");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.auth = action.payload;
                state.error = null;
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Forgot Password
            .addCase(clientForgotPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(clientForgotPassword.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(clientForgotPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Reset Password
            .addCase(clientResetPassword.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(clientResetPassword.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(clientResetPassword.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });;
    },
});

export const { logout } = authSlice.actions;
export const selectClientAuth = (state) => !!state.clientAuth.auth;
export default authSlice.reducer;
